import { render, staticRenderFns } from "./scene9.vue?vue&type=template&id=0022d0ce&scoped=true&"
import script from "./scene9.vue?vue&type=script&lang=ts&"
export * from "./scene9.vue?vue&type=script&lang=ts&"
import style0 from "./scene9.vue?vue&type=style&index=0&id=0022d0ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022d0ce",
  null
  
)

export default component.exports